import { DetailTemplate } from "../../templates/DetailTemplate";
import { MainTemplate } from "../../templates/MainTemplate";
import { useGroupDetail } from "./hook";

export const GroupDetailPage: React.FC = () => {
  const { canEdit, groupDetail, handleCancel, handleEdit } = useGroupDetail();

  return (
    <MainTemplate title="グループ詳細" useFitHeight>
      <DetailTemplate
        detailItems={groupDetail}
        onCancel={handleCancel}
        onEdit={handleEdit}
        canEdit={canEdit}
      />
    </MainTemplate>
  );
};
